export { default } from './withMobileDialog';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/withMobileDialog/index.js
// module id = 836
// module chunks = 121